import { render, staticRenderFns } from "./PidReportActivity.vue?vue&type=template&id=87dcd9e4&scoped=true&"
import script from "./PidReportActivity.vue?vue&type=script&lang=js&"
export * from "./PidReportActivity.vue?vue&type=script&lang=js&"
import style0 from "./PidReportActivity.vue?vue&type=style&index=0&id=87dcd9e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dcd9e4",
  null
  
)

export default component.exports